/**
 * Filtra elementos de navegación según el rol del usuario con jerarquía
 * @param {Array} navs - Array de elementos de navegación con propiedad role
 * @param {Object} user - Objeto usuario con propiedades is_superuser, is_admin, is_tech
 * @returns {Array} - Navegación filtrada según permisos
 */
export const filterNavsByRole = (navs, user) => {
    if (!user) return [];
    const sensors = user.panel.sensors

    return navs.filter(nav => {
        // El role define el nivel mínimo requerido
        const role = nav.role || nav.roles;

        // Superuser puede acceder a  t o d o
        if (user.is_superuser) return true;

        // Admin puede acceder a items marcados como tech o admin
        if (user.is_admin && (role === "tech" || role === "admin")) return true;

        // Tech solo puede acceder a items marcados como tech
        if (user.is_tech && role === "tech") return true;

        return false;
    });
};
/**
 * Filtra elementos de navegación según el rol del usuario con jerarquía
 * @param {Array} navs - Array de elementos de navegación con propiedad role
 * @param {Object} user - Objeto usuario extraemos los modelos del panel activo.
 * @returns {Array} - Navegación filtrada según permisos
 */
export const filterNavsBymodel = (navs, user) => {
    if (!user) return [];
    // Modelos del panel activo
    const sensors = user.panel.sensors

    return navs.filter(nav => {
        if (!nav.models || nav.models.length === 0) {
            return true;
        }
        return nav.models.some(model => sensors.includes(model));
    });
};

/**
 * Filtra elementos de navegación según el tipo de panel activo.
 * Items sin panel_type son visibles en todos los paneles.
 * @param {Array} navs - Array de elementos con propiedad opcional panel_type
 * @param {Object} panel - Objeto panel con propiedad panel_type
 * @returns {Array} - Navegación filtrada por panel
 */
export const filterNavsByPanel = (navs, panel) => {
    if (!navs) return [];
    if (!panel) return navs;
    return navs.filter(nav => !nav.panel_type || nav.panel_type === panel.panel_type);
};